import {
  Button,
  HStack,
  Icon,
  Text,
  VStack,
  useDisclosure,
} from '@chakra-ui/react';
import { useEffect } from 'react';
import { AiFillCheckCircle, AiOutlinePlus } from 'react-icons/ai';

import { GiftCodeInputModalContainer } from '~/components/gift_code/GiftCodeInputModalContainer';

import { PlayTicket } from '~/types/resources';

type Props = {
  playTickets: PlayTicket[];
  setPlayTicket: (playTicket: PlayTicket) => void;
  selectedPlayTicket: PlayTicket | null;
};

export const SelectPlayTicketForm: React.FC<Props> = (props: Props) => {
  const registerPlayTicketDisclosure = useDisclosure();

  // biome-ignore lint/correctness/useExhaustiveDependencies: ロード時のみ実行
  useEffect(() => {
    if (props.playTickets.length === 0) return;
    if (props.selectedPlayTicket !== null) return;

    // 初回マウント時にselectedPlayTicketがnullの場合、かつ要素が一つしかない場合選択済みにする
    if (props.playTickets.length === 1) {
      props.setPlayTicket(props.playTickets[0]);
    }
  }, []);

  return (
    <VStack gap={4}>
      <VStack w="full">
        {props.playTickets.map((playTicket) => {
          const onCheck = () => {
            props.setPlayTicket(playTicket);
          };
          const isChecked =
            props.selectedPlayTicket?.template_id === playTicket.template_id;
          return (
            <HStack
              key={playTicket.template_id}
              rounded="lg"
              borderWidth={2}
              borderColor={isChecked ? 'webroll.500' : 'disable'}
              w="full"
              p={4}
              gap={4}
              onClick={onCheck}
            >
              <Icon
                as={AiFillCheckCircle}
                color={isChecked ? 'primary' : 'disable'}
                h={4}
                w={4}
              />
              <VStack gap={2} alignItems="start">
                <Text fontSize="md" fontWeight="bold" colorPalette="gray.700">
                  {playTicket.name}
                </Text>
                <Text px={1}>{playTicket.quantity}枚所持</Text>
              </VStack>
            </HStack>
          );
        })}
      </VStack>
      <VStack>
        <Button
          size="sm"
          variant="outline"
          colorPalette="webroll"
          onClick={registerPlayTicketDisclosure.onOpen}
        >
          <AiOutlinePlus />
          ギフトコードをお持ちの場合はこちら
        </Button>
      </VStack>
      <GiftCodeInputModalContainer disclosure={registerPlayTicketDisclosure} />
    </VStack>
  );
};
